import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ApiSettingsService } from './api-settings.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private http: HttpClient,
    public apiSettingsService: ApiSettingsService,
  ) {}

  getRequest(queryString: string, params?: string): Observable<any> {
    return this.http.get(params ? queryString + params : queryString);
  }

  createTripAI(params: string): Observable<any> {
    return this.getRequest(
      this.apiSettingsService.apiUrl + 'api/trip-planner/createTempItinerary',
      params,
    );
  }

  getRegion(country: string, region: string): Observable<any> {
    return this.getRequest(
      this.apiSettingsService.apiUrl +
        'api/info/destinations/' +
        country +
        '/' +
        region,
    );
  }
}
